import { notify } from '../../actions/notifications';
import { changeFrequency } from '../../actions/savedSearches/actions';
import {
  TWebDisableSubscriptionResponse,
  fetchWebDisableSubscription,
} from '../../repositories/saved-searches/v1/web/disable-subscription';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export interface IUnsubscribeFromSearchParameters {
  id: number;
}

export const unsubscribeFromSearch =
  ({ id }: IUnsubscribeFromSearchParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () =>
      dispatch(notify('Что-то пошло не так. Попробуйте повторить попытку позже', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TWebDisableSubscriptionResponse = await fetchWebDisableSubscription({
        httpApi,
        parameters: {
          savedSearchId: id,
        },
      });

      if (statusCode === 200) {
        dispatch(changeFrequency({ id, frequency: null, status: 'not_subscribed' }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Failed unsubscribe saved searches (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, { description: 'Failed unsubscribe saved searches' });
    }
  };
